module.exports = {"title":"หน้าจอ","ipAddress":"IP Address","code":"รหัส","macAddress":"MAC Address","mac":"MAC Address","license":"License","room":"ห้อง","status":"สถานะ","model":"โมเดล","turnOn":"เปิด","turnOff":"ปิด","create":"เพิ่ม หน้าจอ","update":"แก้ไข หน้าจอ","view":"รายละเอียด หน้าจอ","turnonSuccess":"เปิด หน้าจอสำเร็จ","turnoffSuccess":"ปิด หน้าจอสำเร็จ","lock":"Lock","unlock":"Unlock","lockSuccess":"Lock หน้าจอสำเร็จ","unlockSuccess":"Unlock หน้าจอสำเร็จ"}


//////////////////
// WEBPACK FOOTER
// ./src/language/th/display.json
// module id = 1014
// module chunks = 10